import React, { useContext } from 'react';
import { KFLDropmenugroup, KFLDropmenuitem } from '@kamstrup/kamstrup-frontend-library';
import { LocaleCtx } from '../../contexts/locale.context';
import { AppKeys } from '../../core/localization/const';
import { Settings } from '../../variables';

export const AppLinks: React.FC = () => {
    const { translate } = useContext(LocaleCtx);

    const MyKamstrupLink = (
      <KFLDropmenuitem
        key={AppKeys.app_links_myk}
        text={translate(AppKeys.app_links_myk)}
        onClick={() => window.location.assign(Settings.ENV_MYKAMSTRUP_URL)}
      />
    );
    
    const GuidesLink = (
      <KFLDropmenuitem
        key={AppKeys.app_links_guides}
        text={translate(AppKeys.app_links_guides)}
        onClick={() => window.location.assign(Settings.ENV_EKSGUIDES_URL)}
      />
    );

 return <KFLDropmenugroup>{MyKamstrupLink}{GuidesLink}</KFLDropmenugroup>
}

export default AppLinks;